module.exports = __webpack_public_path__ + "media/note.300ff935.mp3";